import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useShop } from "@/store";
import { M } from "@/data/catalogue";

export function Colorway({ p }) {
  return (
    <span className="colorway">
      {p.color.map((c) => (
        <i key={c} style={{ background: c }} />
      ))}
    </span>
  );
}

export default function ProductCard({ p }) {
  const { t, money, wish, toggleWish, setDrawer } = useShop();
  const onWish = wish.includes(p.id);
  const spot = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };
  return (
    <div className="pcard" data-testid={`product-card-${p.id}`}>
      <Link className="ph" to={`/product/${p.id}`} aria-label={p.n} onMouseMove={spot}>
        <img src={M[p.img]} alt={`${p.n} Wayuu bag`} loading="lazy" />
        <span className={`tag${p.one ? "" : " sold"}`}>{p.one ? t("shop.ofone") : t("shop.lim")}</span>
      </Link>
      <button
        className={`icon wish${onWish ? " on" : ""}`}
        data-testid={`wishlist-toggle-${p.id}`}
        aria-label={`Wishlist ${p.n}`}
        aria-pressed={onWish}
        onClick={() => toggleWish(p.id)}
      >
        <Heart />
      </button>
      <button className="quick" data-testid={`quick-view-${p.id}`} onClick={() => setDrawer({ type: "quick", id: p.id })}>
        {t("shop.quick")}
      </button>
      <div className="meta">
        <Link className="name" to={`/product/${p.id}`}>{p.n}</Link>
        <span className="price">{money(p.price)}</span>
      </div>
      <div className={`sub${p.one ? "" : " mute"}`}>
        {p.one ? t("pdp.one") : t("pdp.lim")} · <Colorway p={p} />
      </div>
    </div>
  );
}
